import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import IconButton from '@material-ui/core/IconButton';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EmailIcon from '@material-ui/icons/Email';
import DetailsIcon from '@material-ui/icons/Details';
import EditIcon from '@material-ui/icons/Edit';
import Tooltip from '@material-ui/core/Tooltip';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Fade from '@material-ui/core/Fade';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Button from '@material-ui/core/Button';
import { ConfirmAction } from '../../dialogs'
import CaseApi from '../../../libs/EdgeVMSCloudApi/Cases'
import { SERVICES, OPERATIONS } from '../../../constants/permissions'

const useStyles = theme => ({
  actionsDropDown: {
    marginRight: theme.spacing(6),
  },
  actionsMenuIcon: {
    minWidth: theme.spacing(4),
  },
});

function DetailsAction(props) {
  const { caseId, session, disabled, dense, dropDownVariant } = props
  const hasReadPermission = session.permissions[SERVICES.CASE][OPERATIONS.READ]
  const hasUpdatePermission = session.permissions[SERVICES.CASE][OPERATIONS.UPDATE]

  if (dropDownVariant || !(hasReadPermission || hasUpdatePermission)) {
    return null
  }

  return (
    <Fragment>
      <Tooltip title={hasUpdatePermission ? "Edit" : "Details"}>
        <IconButton
          disabled={disabled}
          size={dense ? 'small' : 'medium'}
          onClick={() => props.history.push('/mainmenu/exchange/details/' + caseId)}
        >
          { hasUpdatePermission ?
            <EditIcon fontSize={dense ? 'small' : 'default'}/> :
            <DetailsIcon fontSize={dense ? 'small' : 'default'}/>
          }
        </IconButton>
      </Tooltip>
    </Fragment>
  )
}

class EmailCase extends Component {

  constructor(props) {
    super(props)

    this.state = {
      showActionProgress: false,
      confirmEmailActionOpen: false,
    }

    this.abortController = new AbortController();
    this.signal = this.abortController.signal;
  }

  componentWillUnmount() {
    this.abortController.abort();
  }

  onEmailActionClick() {
    if (this.props.closeMenu){
      this.props.closeMenu()
    }

    this.setState({showActionProgress: false})
    this.setState({confirmEmailActionOpen: true})
  }

  async EmailActionCallback (userAnswer, toEmail) {
    if (userAnswer && userAnswer === 'ok' && toEmail) {
      this.setState({showActionProgress: true})
      const response = await CaseApi.SendCaseEmail(this.signal, toEmail)
      if (response.error && response.error.name === "AbortError") {
        return;
      }
    }
    this.setState({confirmEmailActionOpen: false})
  }

  render() {
    const { session, classes, disabled, dense, dropDownVariant } = this.props;

    if (!session.permissions[SERVICES.CASE][OPERATIONS.UPDATE])
    {
      return null
    }

    return (
      <Fragment>
        { dropDownVariant ? (
          <MenuItem onClick={this.onEmailActionClick.bind(this)}>
            <ListItemIcon className={classes.actionsMenuIcon}>
              <EmailIcon fontSize='small' />
            </ListItemIcon>
            Send Email
          </MenuItem>
        ) : (
          <Tooltip title="Send Email">
            <IconButton
              disabled={disabled}
              size={dense ? 'small' : 'medium'}
              onClick={this.onEmailActionClick.bind(this)}
            >
              <EmailIcon fontSize={dense ? 'small' : 'default'}/>
            </IconButton>
          </Tooltip>
        )}

        <ConfirmAction
          title="Resend Email ?"
          open={this.state.confirmEmailActionOpen}
          showProgress={this.state.showActionProgress}
          progressMsg="Processing request to resend case email..."
          actionCallback={this.EmailActionCallback.bind(this)}
          callbackContext={this.props.caseId}
        >
          Are you sure you want to email new credentials for this case?<br/>
          This will invalidate any previously sent credentials.<br/>
          This operation is IRREVERSIBLE!
        </ConfirmAction>
      </Fragment>
    )
  }
}

class DeleteCase extends Component {

  constructor(props) {
    super(props)

    this.state = {
      showActionProgress: false,
      confirmDeleteActionOpen: false,
    }

    this.abortController = new AbortController();
    this.signal = this.abortController.signal;
  }

  componentWillUnmount() {
    this.abortController.abort();
  }

  onDeleteActionClick() {
    if (this.props.closeMenu){
      this.props.closeMenu()
    }

    this.setState({showActionProgress: false})
    this.setState({confirmDeleteActionOpen: true})
  }

  async DeleteActionCallback(userAnswer, toDelete) {
    if (userAnswer && userAnswer === 'ok' && toDelete) {
      this.setState({showActionProgress: true})
      const response = await CaseApi.DeleteCase(this.signal, toDelete)
      if (response.error && response.error.name === "AbortError") {
        return;
      }

      this.setState({confirmDeleteActionOpen: false})

      // Call this last because it will probably result in the component being unmounted.
      if (this.props.onConfirmDelete) {
        await this.props.onConfirmDelete();
      }
    } else {
      this.setState({confirmDeleteActionOpen: false})
    }
  }

  render() {
    const { session, classes, disabled, dense, dropDownVariant } = this.props;

    if (!session.permissions[SERVICES.CASE][OPERATIONS.DELETE])
    {
      return null
    }

    return (
      <Fragment>
        { dropDownVariant ? (
          <MenuItem onClick={this.onDeleteActionClick.bind(this)}>
            <ListItemIcon className={classes.actionsMenuIcon}>
              <DeleteForeverIcon fontSize='small' />
            </ListItemIcon>
            Delete Forever
          </MenuItem>
        ) : (
          <Tooltip title="Delete Forever">
            <IconButton
              disabled={disabled}
              size={dense ? 'small' : 'medium'}
              onClick={this.onDeleteActionClick.bind(this)}
            >
              <DeleteForeverIcon fontSize={dense ? 'small' : 'default'} />
            </IconButton>
          </Tooltip>
        )}

        <ConfirmAction
          title="Delete Case ?"
          open={this.state.confirmDeleteActionOpen}
          showProgress={this.state.showActionProgress}
          progressMsg="Processing request to delete case..."
          actionCallback={this.DeleteActionCallback.bind(this)}
          callbackContext={this.props.caseId}
        >
          Are you sure you want to permanently delete this case?<br/>
          This operation is IRREVERSIBLE!
        </ConfirmAction>
      </Fragment>
    )
  }
}

class ExchangeActions extends Component {
  constructor (props) {
    super(props)

    this.state = {
      userMenuAnchor: null,
    }
  }

  closeMenu = () => {
    this.setState({userMenuAnchor: null})
  }

  render () {
    const { session, classes, disabled, dropDownVariant } = this.props
    const { userMenuAnchor } = this.state

    if ((!session.permissions[SERVICES.CASE][OPERATIONS.READ] || dropDownVariant) &&
         !session.permissions[SERVICES.CASE][OPERATIONS.UPDATE] &&
         !session.permissions[SERVICES.CASE][OPERATIONS.DELETE]) {
      if (dropDownVariant) {
        return null
      } else {
        return "None"
      }
    }

    if (dropDownVariant) {
      return (
        <Fragment>
          <Button
            disabled={disabled}
            className={classes.actionsDropDown}
            variant='outlined'
            color="inherit"
            endIcon={Boolean(userMenuAnchor) ? <ExpandLessIcon/> : <ExpandMoreIcon/>}
            onClick={(event) => this.setState({userMenuAnchor: event.currentTarget})}
          >
            ACTIONS
          </Button>
          <Menu
            id="actions-menu"
            anchorEl={userMenuAnchor}
            keepMounted
            TransitionComponent={Fade}
            getContentAnchorEl={null}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
            open={Boolean(userMenuAnchor)}
            onClose={this.closeMenu}
          >
            <EmailCase {...this.props} closeMenu={this.closeMenu}/>
            <DeleteCase {...this.props} closeMenu={this.closeMenu}/>
          </Menu>
        </Fragment>
      )
    } else {
      return (
        <Fragment>
          <DetailsAction {...this.props}/>
          <EmailCase {...this.props}/>
          <DeleteCase {...this.props}/>
        </Fragment>
      )
    }
  }
}

export default withRouter(withStyles(useStyles)(ExchangeActions))
